import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

import { BidNotificationInfo, BmDataAccessFacade } from '@nexweb/shared/data-access/bm';

import { ActivationExtension, Headings, Labels } from '../../../models/request-extension-of-activation-period.models';
import { RequestExtensionOfActivationPeriodService } from '../../../services';
import { ExtensionFormComponent } from '../extension-form/extension-form.component';

@Component({
  selector: 'nexweb-ext-sup-tso-not',
  templateUrl: './ext-sup-tso-not.component.html',
  imports: [AsyncPipe, ExtensionFormComponent],
})
export class ExtSupTsoNotComponent implements OnInit {
  @Input() bidId: number;

  public extension$: Observable<ActivationExtension>;
  public dateTimeFormat: string;
  public labels: Labels;
  public headings: Headings;

  private bmFacade = inject(BmDataAccessFacade);
  private requestExtensionOfActivationService = inject(RequestExtensionOfActivationPeriodService);

  ngOnInit(): void {
    this.labels = this.requestExtensionOfActivationService.getNotificationLabels();
    this.headings = this.requestExtensionOfActivationService.getNotificationHeadings();
    this.dateTimeFormat = this.requestExtensionOfActivationService.getDateTimeFormat();

    this.initialiseData();
  }

  private initialiseData(): void {
    this.extension$ = this.bmFacade.getBidNotificationInfo(this.bidId).pipe(
      map((bidNotificationInfo: BidNotificationInfo) => {
        const bidNotificationData = {
          name: bidNotificationInfo.requestingTsoName,
          telephoneNumber: bidNotificationInfo.requestingTsoPhoneNumber,
          portfolio: bidNotificationInfo.requestingTsoPortfolioName,
          requestedQuantity: bidNotificationInfo.requestedQuantity,
          instrument: bidNotificationInfo.instrument,
          requestedActivationTime: bidNotificationInfo.requestFullDispatchTime,
        } as ActivationExtension;

        return bidNotificationData;
      }),
    );
  }
}
